export const FIAT_WALLET_ENDPOINTS = {
  FIAT_WALLET: '/api/wallets/fiat',
  DEPOSIT_ACCOUNT: '/api/wallets/fiat/deposit-account',
  FIAT_WALLET_WITHDRAWAL: '/api/wallets/fiat/withdrawals',
  ADD_FUNDS: '/api/wallets/fiat/deposits',
} as const
